import PermissionManagement from "./plugins/Permissions";

// Remove spinner right away
document.documentElement.classList.remove("loading");

// Check that service workers are supported
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js");
  });
}

window.onload = function() {
  // Submit buttons Spinner
  const buttons = document.querySelectorAll("[type=submit]");
  const spinners = document.querySelector(".btn .spinner-border");
  if (buttons && spinners) {
    buttons.forEach(button => {
      button.onclick = function() {
        button.disabled = true;
        spinners.classList.remove("d-none");
        this.form.submit();
      };
    });
  }

  // Options conditional logic
  const inputType = document.getElementById("column-type");
  if (inputType) {
    inputType.onchange = function() {
      let hiddenDiv = document.getElementById("inputTypeArray");
      this.value == "option"
        ? hiddenDiv.classList.remove("d-none")
        : hiddenDiv.classList.add("d-none");
    };
  }

  // Create new report logic
  const submitBtn = document.getElementById("create-report-submit");
  const templateDropdown = document.getElementById("report_template_id");
  if (submitBtn && templateDropdown) {
    submitBtn.disabled = true;
    templateDropdown.onchange = function() {
      if (templateDropdown.value) {
        submitBtn.disabled = false;
      } else {
        submitBtn.disabled = true;
      }
    };
  }
};

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.Vue = require("vue");
import BootstrapVue from "bootstrap-vue";
// import VueMaterial from "vue-material";
// import "vue-material/dist/vue-material.min.css";
// import "vue-material/dist/theme/default.css";
import VueI18n from "vue-i18n";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import fullscreen from "vue-fullscreen";
import VueMoment from "vue-moment";
import ResizableTextarea from "./components/Common/ResizableTextarea.js";
import store from "./store";
import Toasted from "vue-toasted";
import { ZiggyVue } from "ziggy-js";
import { Ziggy } from "./ziggy";

library.add(fas);

Vue.use(BootstrapVue);
// Vue.use(VueMaterial);
Vue.use(Toasted);
Vue.use(VueI18n);
Vue.use(fullscreen);
Vue.use(VueMoment);
Vue.use(ZiggyVue, Ziggy);
Vue.component("resizable-textarea", ResizableTextarea);
Vue.component("pagination", require("laravel-vue-pagination"));
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.prototype.$isStandalone = window.matchMedia("(display-mode: standalone)")
  .matches
  ? true
  : false;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const files = require.context("./", true, /\.vue$/i);
files.keys().map(key => {
  const name = key
    .split("/")
    .slice(2)
    .map(segment =>
      segment
        .replace(/\.vue$/i, "")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .toLowerCase()
    )
    .join("-");

  Vue.component(name, files(key).default);
});

/**
 * Translations
 */
import { languages, defaultLocale } from "../lang/index.js";
const messages = Object.assign(languages);

function setI18nLanguage(lang) {
  document.querySelector("html").setAttribute("lang", lang);
  return lang ? lang : defaultLocale;
}

var i18n = new VueI18n({
  locale: setI18nLanguage(),
  fallbackLocale: defaultLocale,
  silentTranslationWarn: true,
  messages
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.use(PermissionManagement);

const app = new Vue({
  i18n,
  store,
  el: "#app"
});
